module.exports = __webpack_public_path__ + "static/media/state-state6.153a32c9.png";